// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-comment-dialog',
    // #endregion
    // #region Mixins
    mixins: [host.mixins.modal],
    // #endregion
    // #region Properties
    props: {
        cartID: {
            type: String,
            required: false,
            default: ''
        },
        comment: {
            type: String,
            required: false,
            default: ''
        },
        callback: {
            type: Function,
            required: false
        },
    },
    // #endregion
    // #region Properties
    data: () => ({
        _comment: ''
    }),
    // #endregion
    // #region Boostrap
    created() {
        this._comment = this.comment;
    },
    // #endregion
    // #region Methods
    methods: {
        onCreate() {
            // #region Args
            let tCart = {
                comment: this._comment
            };
            // #endregion
            // #region Send
            host.api.patch(`commerce/carts/${this.cartID}`, tCart)
                .then(e => {
                // #region Store
                this.$store.commit('carts/load');
                // #endregion
                // #region Close
                this.currentWindow.close();
                // #endregion
                // #region Callaback
                if (this.callback) {
                    this.callback();
                }
                // #endregion
            })
                .catch(e => {
                host.notification.showToast(utils.getAxiosErrorMessage(e));
            });
            // #endregion
        }
    }
    // #endregion
});
// #endregion
